<template>
    <div>
        <div class="maps-container">
            <div class="alert-container" v-if="refuseGeolocation"> 
                <div class="alert">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="cross" @click="refuseGeolocation = false">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7464 4.58325L9.96635 9.36325L5.18594 4.58325L4.58594 5.18284L9.36594 9.96367L4.58594 14.7437L5.18594 15.3441L9.96635 10.5633L14.7668 15.3641L15.3668 14.7641L10.5664 9.96367L15.3468 5.16284L14.7464 4.58325Z" fill="black"/>
                    </svg>
                    <span v-html="$t('store_locator.error_location')"></span>
                </div>
            </div>
            <div class="container-selection guideline-span pt-lg-40 pt-24 px-lg-40 px-24" >
                <h2  v-html="$t('store_locator.title')"></h2>
                <h5 class=" mt-8"> {{ $t('store_locator.description') }}</h5>
                <div class="mt-lg-32 mt-24 autocomplete-container ">
                    <div class="search-container">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.6828 5.40647C24.9424 9.36109 25.311 15.9766 21.5172 20.38L29.2372 28.1L28.1039 29.2333L20.3839 21.5133C15.9805 25.3071 9.36499 24.9385 5.41038 20.6789C1.45577 16.4193 1.57871 9.79468 5.68865 5.68474C9.79858 1.5748 16.4232 1.45186 20.6828 5.40647ZM13.3372 4.1333C8.25619 4.1333 4.13721 8.25228 4.13721 13.3333C4.14089 18.4128 8.25771 22.5296 13.3372 22.5333C18.4182 22.5333 22.5372 18.4143 22.5372 13.3333C22.5372 8.25228 18.4182 4.1333 13.3372 4.1333Z" fill="black"/>
                            <path d="M20.6828 5.40647C24.9424 9.36109 25.311 15.9766 21.5172 20.38L29.2372 28.1L28.1039 29.2333L20.3839 21.5133C15.9805 25.3071 9.36499 24.9385 5.41038 20.6789C1.45577 16.4193 1.57871 9.79468 5.68865 5.68474C9.79858 1.5748 16.4232 1.45186 20.6828 5.40647ZM13.3372 4.1333C8.25619 4.1333 4.13721 8.25228 4.13721 13.3333C4.14089 18.4128 8.25771 22.5296 13.3372 22.5333C18.4182 22.5333 22.5372 18.4143 22.5372 13.3333C22.5372 8.25228 18.4182 4.1333 13.3372 4.1333Z" stroke="black"/>
                        </svg>

                        <input type="text" :placeholder="$t('store_locator.placeholder')"  id="autocomplete" class="autocomplete" v-model="inputValue"   >
                        <div v-if="inputValue !== null">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" class="-pointer" xmlns="http://www.w3.org/2000/svg" @click="closeSearch()">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7444 4.5835L9.9644 9.3635L5.18398 4.5835L4.58398 5.18308L9.36398 9.96391L4.58398 14.7439L5.18398 15.3443L9.9644 10.5635L14.7648 15.3643L15.3648 14.7643L10.5644 9.96391L15.3448 5.16308L14.7444 4.5835Z" fill="black"/>
                            </svg>
                        </div>
                    </div>
                    <span class="location-link guideline-small -pointer mb-40" @click="getUserLocation" v-if="!place?.formatted_address">
                        <svg class="icon icon-navigation-pin" width="16" height="16">
                            <use xlink:href="#icon-navigation-pin"></use>
                        </svg>
                        {{ $t('store_locator.location') }}
                    </span>
                </div>
                <div class=" my-16" v-if="currentMarker">
                    <a @click="closeDetail"  class="show-detail " v-if="showDetail && currentMarker"> 
                        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.875 0.837695L0.991667 6.0002L7.875 11.1627L7.35 11.8627L0 6.3502V5.6502L7.35 0.137695L7.875 0.837695Z" fill="black"/>
                        </svg>
                        {{ $t('store_locator.return_list') }}
                    </a>
                    <!-- <div class="filter-button " v-show="!showDetail && currentMarker ">
                        <renault-button :text="$t('store_locator.button_filter')" is-small is-grey @buttonclicked="showFilterList"  reverse class="gap-4 " v-if="selectedActivities.length == 0 && !filterOpen">
                            <svg class="icon icon-filter" width="16" height="16">
                            <use xlink:href="#icon-filter"></use>
                        </svg>
                        </renault-button>
                        <a v-show="!showDetail && filteredMarkers.length > 0 && selectedActivities.length > 0" @click="resetFilter" class="reset -pointer" > {{ $t('store_locator.reset') }}</a>
                    </div> -->
                </div>

                <transition  name="slide-down">
                    <div class="list-agencies -desktop" v-if="!filterOpen && currentMarker && !showDetail">
                        <template v-for="(marker, key) in filteredMarkers" v-if="!showDetail">
                            <agency :item="marker" :index="key" @markerDetail="markerDetail" :current-place="place" :location="isLocation" />
                        </template>
                    </div>
                </transition>
                <transition  name="slide-down">
                    <additional-infos :item="markerSelect" v-if="showDetail && !filterOpen" :index="keySelected"  :location="isLocation" :current-place="place"  class="-desktop-only"/>
                </transition>
               

                <!-- <div v-show="filterOpen && currentMarker" class=" pt-24 pb-lg-40 pb-24 filter-list ">
                    <filter-list @validateFilter="validateFilter" @closeFilter="closeFilter" :is-reset="isReset" />
                </div> -->
               
            </div>
            <div id="map" ></div>

            <transition  name="slide-down">
                <div class="list-agencies -mobile" v-if="!filterOpen && currentMarker && !showDetail" >
                    <div class="content " ref="innerContent" >
                        <div class="inner-content">
                            <template v-for="(marker, key) in filteredMarkers" v-if="!showDetail">
                                <agency :item="marker" :index="key" @markerDetail="markerDetail"  :current-place="place" :location="isLocation"  />
                            </template>
                            
                        </div>
                    </div>
                </div>
            </transition>
            <transition  name="slide-down">
                <additional-infos :item="markerSelect" v-if="showDetail && !filterOpen" :index="keySelected"  :current-place="place" :location="isLocation" class="-mobile-only" />
            </transition>
            
        </div>
    </div>
</template>

<script>
import Agency from "./Agency.vue";
import AdditionalInfos from "./AdditionalInfos.vue";
import FilterList from "./FilterList.vue";
import mixinStore from './mixins';
import RenaultButton from "../Shared/RenaultButton.vue";
import gsap from "gsap";

export default {
    components: {
        Agency,
        AdditionalInfos,
        FilterList,
        RenaultButton,
    },
    mixins: [mixinStore],

    data() {
        return {
            markers: window.data.stores,
            map: null,
            infoWindow: null,
            autocomplete: null,
            placeService: null,
            filteredMarkers: [],
            markerSelect:null,
            showDetail: false,
            keySelected: null,
            filterOpen: false,
            selectedActivities: [],
            placeDetails: [],
            place: null,
            isCurrentlyOpen: false,
            inputValue: null,
            isReset: false,
            mobileHeight: window.innerHeight,
            maxHeightInitial: 250,
            maxHeightFinal: window.innerHeight - 80 - 248 - 30,
            currentMaxHeight: 250,
            lastScrollDelta: 0,
            
        };
    },

    mounted() {
        this.loadGoogleMapsAPI()
        .then(() => {
            this.initMap();
        })
        .catch((error) => {
            console.error("Google Maps API failed to load:", error);
        });
    },
    watch: {
        showDetail(newValue) {
           if(newValue) this.currentMaxHeight = this.maxHeightFinal
        }
    },
    methods: {
        onWheel(event) {
            if (this.isAnimating) return; 
            const { scrollTop, scrollHeight, clientHeight } = this.$refs.innerContent;
            const atLimit = (event.deltaY < 0 && scrollTop === 0) ||  (event.deltaY > 0 && scrollTop + clientHeight >= scrollHeight);
            if (atLimit) {
                const targetHeight = event.deltaY > 0 ? Math.min(this.currentMaxHeight + 50, this.maxHeightFinal)  : Math.max(this.currentMaxHeight - 50, this.maxHeightInitial);
                this.animateHeight(targetHeight);
                event.preventDefault(); 
            }
        },

        animateHeight(targetHeight) {
            const container = this.$refs.scrollContainer;
            gsap.to(container, {
                duration: 0.1,
                maxHeight: targetHeight,
                ease: "power1.out", 
                onUpdate: () => {
                    const newHeight = parseFloat(getComputedStyle(container).maxHeight);
                    if (this.currentMaxHeight !== newHeight) {
                        this.currentMaxHeight = newHeight;
                    }
                },
                onComplete: () => {
                    this.currentMaxHeight = targetHeight;
                },
            });
        },
    },
};
</script>

<style lang="scss" >
$heightMapMob: 200px;
$heightMap: calc(100vh - 117px);


#map {
    height: $heightMapMob;
    width: 100%;

    @include teq-breakpoint($medium) {
        height: $heightMap;
    }
}

.container {
    position: relative;
}

.filter-button {
    display: flex;
    justify-content: space-between;

    .renault-button {
        font-size: 12px !important;
    }


    .reset {
        font-family: $f-nouvelR-semibold;
        font-size: 12px;
        line-height: 16px;
        text-decoration: underline;
    }
}

.maps-container {
    position: relative;

    .container-selection {
        background-color: white;
        z-index: 2;

        h2,
        h5 {
            font-family: $f-nouvelR-bold;
        }

        @include teq-breakpoint($medium) {
            left: 80px;
            max-height: calc(100vh - 117px - 80px);
            overflow: auto;
            position: absolute;
            top: 80px;
            width: 723px;
        }
    }

    .alert-container {
        background-color: rgba(0, 0, 0, 0.7);
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 3;

        .cross {
            cursor: pointer;
            position: absolute;
            right: 10px;
            top: 10px;
        }

        .alert {
            background-color: white;
            font-family: $f-nouvelR-semibold;
            font-size: 16px;
            left: 50%;
            line-height: 18px;
            max-width: 100%;
            padding: 24px;
            padding-top: 32px;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            width: calc(100% - 32px);
            z-index: 5;

            @include teq-breakpoint($medium) {
                max-width: 360px;
            }
        }
    }

    .content {
        background-color: white;
        overflow-y: auto;

        @include teq-breakpoint($medium) {
            height: 100%;
        }
    }
}


.list-agencies {
    flex-direction: column;

    @include teq-breakpoint($medium) {
        gap: 8px;
        padding-bottom: 40px;
        padding-top: 0;
    }

    &.-mobile {
        width: 100%;

        @include teq-breakpoint($medium) {
            display: none;
        }
    }

    &.-desktop {
        display: none;

        @include teq-breakpoint($medium) {
            display: flex;
        }
    }
}

.search-container {
    align-items: center;
    border: 1px solid #dfdfdf;
    display: flex;
    gap: 12px;
    overflow: hidden;
    padding: 11px 20px;

    @include teq-breakpoint($medium) {
        width: 380px;
    }

    .icon-navigation-search {
        height: 32px;
        width: 32px;
    }

    input {
        border: none;
        color: black;
        flex: 1;
        font-family: $f-nouvelR-semibold;
        font-size: 16px;
        line-height: 18px;

        &::placeholder {
            color: #8c8c8b;
        }
    }

    .ok {
        background-color: black;
        border: none;
        color: white;
        cursor: pointer;
        font-family: $f-nouvelR-bold;
        font-size: 16px;
        line-height: 24px;
        padding: 12px;
    }
}

.location-link {
    align-items: center;
    color: black;
    display: flex;
    gap: 6px;
    margin-top: 32px;
}

.show-detail {
    align-items: center;
    cursor: pointer;
    display: flex;
    font-family: $f-nouvelR-bold;
    font-size: 12px;
    gap: 8px;
    line-height: 16px;
}

.filter-list {
    border-top: 1px solid #dfdfdf;
}
// autocomplete select container
.pac-container {
    background-color: white;
    height: 225px;
    left: 24px !important;
    overflow: auto;
    width: calc(100% - 48px) !important;
    z-index: 2;


    @include teq-breakpoint($medium) {
        left: 120px !important;
        width: 380px !important;
    }

    &::after {
        content: none !important;
    }
}

// autocomplete icon
.pac-icon {
    display: none;
}

// autcomplete icon + text
.pac-item {
    color: $black;
    display: flex;
    flex-direction: column;
    font-family: $f-nouvelR-bold;
    font-size: 16px;
    gap: 1px;
    line-height: 18px;
    padding: 14px 16px;
    padding-left: 48px;
    position: relative;
    white-space: normal;


    &::before {
        content: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45OTkyIDE2LjgwMDJDMTMuMzQ4MyAxNi44MDAyIDExLjE5OTIgMTQuNjUxMiAxMS4xOTkyIDEyLjAwMDJDMTEuMTk5MiA5LjM0OTIzIDEzLjM0ODMgNy4yMDAxOSAxNS45OTkyIDcuMjAwMTlDMTguNjUwMiA3LjIwMDE5IDIwLjc5OTIgOS4zNDkyMyAyMC43OTkyIDEyLjAwMDJDMjAuNzk1NSAxNC42NDk2IDE4LjY0ODcgMTYuNzk2NSAxNS45OTkyIDE2LjgwMDJaTTEyLjc5OTIgMTIuMDAwMkMxMi43OTkyIDEwLjIzMjkgMTQuMjMxOSA4LjgwMDE5IDE1Ljk5OTIgOC44MDAxOUMxNy43NjY1IDguODAwMTkgMTkuMTk5MiAxMC4yMzI5IDE5LjE5OTIgMTIuMDAwMkMxOS4xOTkyIDEzLjc2NzUgMTcuNzY2NSAxNS4yMDAyIDE1Ljk5OTIgMTUuMjAwMkMxNC4yMzE5IDE1LjIwMDIgMTIuNzk5MiAxMy43Njc1IDEyLjc5OTIgMTIuMDAwMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuNzA1OSAzMC41MDAyTDE0Ljk0NTkgMzAuODAwMkgxNy4wNTI2TDE3LjI5MjYgMzAuNTAwMkMyMy41OTkyIDIyLjYxMzUgMjYuNzk5MiAxNi4zODY5IDI2Ljc5OTIgMTIuMDAwMkMyNi43OTkyIDYuMDM1NTIgMjEuOTYzOSAxLjIwMDIgMTUuOTk5MiAxLjIwMDJDMTAuMDM0NSAxLjIwMDIgNS4xOTkyMiA2LjAzNTUyIDUuMTk5MjIgMTIuMDAwMkM1LjE5OTIyIDE2LjM4NjkgOC4zOTkyMiAyMi42MTM1IDE0LjcwNTkgMzAuNTAwMlpNMjUuMTk5MiAxMi4wMDAyQzI1LjE5OTIgMTUuOTYwMiAyMi4xOTkyIDIxLjc0NjkgMTYuMjc5MiAyOS4yMDAySDE1LjcxOTJDOS43OTkyMiAyMS43NDY5IDYuNzk5MjIgMTUuOTYwMiA2Ljc5OTIyIDEyLjAwMDJDNi43OTkyMiA2LjkxOTE4IDEwLjkxODIgMi44MDAyIDE1Ljk5OTIgMi44MDAyQzIxLjA4MDIgMi44MDAyIDI1LjE5OTIgNi45MTkxOCAyNS4xOTkyIDEyLjAwMDJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K");
        left: 24px;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
    }
}
// autocomplete nom du lieu
.pac-item-query {
    font-family: $f-nouvelR-bold;
    font-size: 16px;
    line-height: 18px;
}

// Autocomplete text exact
.pac-matched {
    font-family: $f-nouvelR-extrabold;
}


.GoogleMapPin {
    align-items: center;
    display: flex;
    position: relative;
    z-index: 1;

    &.active {
        transform: scale(1.5);
    }

    &.current {
        .inner {
            background-color: #efdf00;

            &::after {
                border-top-color: #efdf00;
            }
        }

        .index {
            color: $black;
        }
    }

    .inner {
        align-items: center;
        background-color: #000;
        border: 0 solid;
        border-radius: 50%;
        display: flex;
        font-size: 1.4rem;
        font-weight: 700;
        height: 32px;
        justify-content: center;
        position: relative;
        width: 32px;

        &::after {
            border: 14px solid transparent;
            border-width: 18px 14px 0;
            border-bottom-width: 0;
            border-top: 18px solid #000;
            bottom: -10px;
            content: "";
            height: 0;
            left: 50%;
            position: absolute;
            transform: translate(-50%);
            transition: border-color 0.5s;
            width: 0;
            z-index: -1;
        }
    }

    .index {
        color: #fff;
        font-size: 1.8rem;
    }
}

.btn-invert {
    border: 1px solid white !important;
    filter: invert(1);

    svg {
        height: 16px !important;
        width: 16px !important;
    }
}

.icon-pin-current {
    height: 44px;
    width: 32px;
}

.-desktop-only {
    display: none;

    @include teq-breakpoint($medium) {
        display: block;
    }
}

.-mobile-only {
    display: block;

    @include teq-breakpoint($medium) {
        display: none;
    }
}

</style>